export default __webpack_public_path__ + "static/media/Imagem4.063046a2.png";